<!--
 * @Description: 项目根组件
 * @Author: hai-27
 * @Date: 2020-02-07 16:23:00
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2022-03-22 19:22:03
 -->
<template>
  <div id="app" name="app">
    <globalImg/>
    <router-view />
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { mapGetters } from 'vuex'
import globalImg from "@/mixinVue/globalImage.vue"
export default {
  data() {
    return {
      activeIndex: '', // 头部导航栏选中的标签
      search: '', // 搜索条件
      register: false, // 是否显示注册组件
      visible: false // 是否退出登录
    }
  },
  components:{
    globalImg
  },
  computed: {
    ...mapGetters(['getUser', 'getNum', 'routeGather'])
  },
  watch: {
    // 获取vuex的登录状态
    getUser: function(val) {
      if (val === '') {
        // 用户没有登录
        this.setShoppingCart([])
      } else {
        // 用户已经登录,获取该用户的购物车信息
        this.$axios
          .post('/api/user/shoppingCart/getShoppingCart', {
            user_id: val.user_id
          })
          .then((res) => {
            if (res.data.code === '001') {
              // 001 为成功, 更新vuex购物车状态
              this.setShoppingCart(res.data.shoppingCartData)
            } else {
              // 提示失败信息
              this.notifyError(res.data.msg)
            }
          })
          .catch((err) => {
            return Promise.reject(err)
          })
      }
    }
  },
  beforeUpdate() {
    this.activeIndex = this.$route.path
  },
  created() {
    // 获取浏览器localStorage，判断用户是否已经登录
    if (localStorage.getItem('user')) {
      // 如果已经登录，设置vuex登录状态
      this.setUser(JSON.parse(localStorage.getItem('user')))
    }
    /* window.setTimeout(() => {
      this.$message({
        duration: 0,
        showClose: true,
        message: `
        <p>如果觉得这个项目还不错，</p>
        <p style="padding:10px 0">您可以给项目源代码仓库点Star支持一下，谢谢！</p>
        <p><a href="https://github.com/hai-27/vue-store" target="_blank">Github传送门</a></p>`,
        dangerouslyUseHTMLString: true,
        type: "success"
      });
    }, 1000 * 60); */
  },
  mounted() {
    // 用户权限配置
    this.$store.dispatch('user/userSetRoute', this.$router.options.routes)
  },
  methods: {
    ...mapActions(['setUser', 'setShoppingCart']),
    // 退出登录
    logout() {
      this.visible = false
      // 清空本地登录信息
      localStorage.removeItem('userInfo')
      // localStorage.setItem('user', '')
      this.$store.commit('user/SET_NAME', '')
      this.$store.commit('user/SET_TOKEN', '')
      var keys = document.cookie.match(/[^ =;]+(?=\=)/g)
      if (keys) {
        for (var i = keys.length; i--;) { document.cookie = keys[i] + '=0;expires=' + new Date(0).toUTCString() }
      }
      sessionStorage.removeItem('vuex')
      // 清空vuex登录信息
      // this.setUser('')
      this.notifySucceed('成功退出登录')
    },
    // 接收注册子组件传过来的数据
    isRegister(val) {
      this.register = val
    },
    // 点击搜索按钮
    searchClick() {
      if (this.search !== '') {
        // 跳转到全部商品页面,并传递搜索条件
        this.$router.push({ path: '/goods', query: { search: this.search }})
        this.search = ''
      }
    }
  }
}
</script>

<style>
body .el-table th.gutter {
  display: table-cell !important;
}
.el-dialog {
  display: flex;
  flex-direction: column;
  margin: 0 !important;
  position: absolute;
  top: 50% !important;
  left: 50% !important;
  transform: translate(-50%, -50%) !important;
}
.el-form-item__label {
    font-size: 14px !important;
}
.form-button {
    font-size: 14px !important;
}
</style>
